import { useContext } from 'react';
import { useForm } from 'react-final-form';
import PostFormContext from '../PostFormContext';
import PollViewContext from './PollViewContext';

const useBackClick = () => {
  const { setView } = useContext(PostFormContext);
  const { save } = useContext(PollViewContext);
  const { getState } = useForm();

  return () => {
    save.current = getState().values;
    setView('base');
  };
};

export default useBackClick;
